import React from 'react';
import { NavBar } from '../../Modules/Navigation/components/NavBar/NavBar';
import ExploreClientSongs from '../../Modules/Song/features/ExploreClientSongs/ExploreClientSongs';
import { useUserClients } from '../../contexts/UserClientsContext';
import PageContentCardContainer from '../../ui/Layout/PageContentCardContainer/PageContentCardContainer';
import LoadingSpinner from '../../SharedComponents/LoadingSpinner/LoadingSpinner';
import styles from './ClientPages.module.css';

const ClientSongsPage = () => {
    const { selectedClient, clientsInitialized, hasErrorLoadingClients } = useUserClients();

    return (
        <>
            <NavBar />
            <PageContentCardContainer>
                {clientsInitialized && selectedClient && (
                    <ExploreClientSongs key={selectedClient.id} clientId={selectedClient.id} />
                )}
                {!clientsInitialized && hasErrorLoadingClients && (
                    <div className={styles.errorMessage}>Sorry, we're experiencing technical issues</div>
                )}
                {!clientsInitialized && !hasErrorLoadingClients && <LoadingSpinner spinnerClassName={styles.spinner} />}
            </PageContentCardContainer>
        </>
    );
};

export default ClientSongsPage;
